// var headers = document.querySelector('.header.blog-header');
// var breadCrumb = document.querySelector('.cstm-main-breadcrumbs')
//   window.addEventListener('scroll', function() {   
//    const scrollPosition = window.scrollY;
//     if(scrollPosition >= 90){
//       headers.classList.remove('blog-header');
//     } else {
//       headers.classList.add('blog-header');   
//     }
//   });
var tabs = document.querySelectorAll('.main-blog-tabs .tab-text');
var content = document.querySelectorAll('.blogs-content');
tabs?.forEach((tab , index) => {
  tab.addEventListener('click', () => {
   content[index].style.display = 'block'
  });
  });


  $(document).ready(function() {
    if ($(window).width() <= 749) {
      $('.slider-cstm__1').wrapAll('<div class="article_main-slider"></div>');
        $('.article_main-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1 ,
            dots: true
    });
    }
 });
                  

$('body').on('click','.search__form_article , .search__form_inner .cut',function(){
  $('.search__form_inner').toggle();
  if ($('.search__form_inner').is(':visible')) {
      $('.search__form_inner input').focus();
    }
});